var _defs, _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVitegoAppIconDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vitego") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "left-wing",
    x1: 37,
    y1: 36,
    x2: 70,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3432FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2465FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC3F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right-wing",
    x1: 96,
    y1: 36,
    x2: 76,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45D8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2795FB"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 28,
    fill: "#0A1121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 36H39.5C45.1 36 48.4 38.3 51 43.2L75 86.6C71.2 91.3 66.3 94 59.4 94C53.6 94 50.3 91.7 47.6 86.5L22 36Z",
    fill: "url(#left-wing)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2 36H106L80.3 83.5L68.2 61.4L77.8 43.1C80.4 38.2 82.7 36 86.2 36Z",
    fill: "url(#right-wing)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitegoAppIconDark);
export default __webpack_public_path__ + "static/media/vitego-app-icon-dark.76da950362caa55d6e85f03798d95188.svg";
export { ForwardRef as ReactComponent };